(function() {
  'use strict';
  
  // Cerca tutte le notifiche APDEV nella pagina
  var notificationEls = document.querySelectorAll('.apdev-notification-widget');
  
  if (notificationEls.length === 0) return;
  
  // Aspetta che il DOM sia caricato
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      notificationEls.forEach(function(el) {
        initNotification(el);
      });
    });
  } else {
    notificationEls.forEach(function(el) {
      initNotification(el);
    });
  }
  
  function initNotification(notificationEl) {
    var delay = parseInt(notificationEl.getAttribute('data-delay')) * 1000;
    var rememberClose = notificationEl.getAttribute('data-remember') === 'true';
    var cookieDays = parseInt(notificationEl.getAttribute('data-cookie-days'));
    var cookieName = notificationEl.getAttribute('data-cookie-name');
    
    // Funzioni per gestire i cookie
    function setCookie(name, value, days) {
      var expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    }
    
    function getCookie(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    
    // Controlla se la notifica è stata chiusa
    if (rememberClose && getCookie(cookieName) === 'closed') {
      return;
    }
    
    // Mostra la notifica dopo il delay
    setTimeout(function() {
      notificationEl.classList.add('apdev-show');
    }, delay);
    
    // Gestione chiusura
    var closeBtn = notificationEl.querySelector('.apdev-notification-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        notificationEl.classList.add('apdev-closing');
        
        if (rememberClose) {
          setCookie(cookieName, 'closed', cookieDays);
        }
        
        setTimeout(function() {
          notificationEl.classList.remove('apdev-show', 'apdev-closing');
        }, 400);
      });
    }
  }
})();